import React, { Component } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  Button,
} from 'reactstrap';
import axios from 'axios';
import { toast } from 'react-toastify';
import config from '../../../config';

// Configure axios for unlocked bookings API
const unlockedBookingsApi = axios.create({
  baseURL: config.dispatchApiUrl,
});

const opsApi = axios.create({
  baseURL: config.opsApiBase,
});

class AssignUnlocked extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      assignVehicleId: '',
      isAssigning: false,
    };
  }

  handleConfirmAssignVehicle = async () => {
    const { assignVehicleId } = this.state;
    const { booking, onClose, onSuccess, assignMode = 'future' } = this.props;
    
    if (!assignVehicleId.trim()) {
      toast.error('Please enter a vehicle ID');
      return;
    }

    const bookingId = booking.id || booking.booking_id;
    this.setState({ isAssigning: true });

    try {
      const operatorName = localStorage.getItem('user_name') || localStorage.getItem('username') || 'Unknown Operator';

      const vehicleIdInt = parseInt(assignVehicleId.trim(), 10);
      let response;

      if (assignMode === 'hourly') {
        response = await opsApi.post('/hourly-unassigned-bookings/assign', {
          booking_id: bookingId,
          vehicle_id: vehicleIdInt,
          assigned_by: operatorName,
          source: 'hourly_unassigned_tab'
        });
      } else {
        response = await unlockedBookingsApi.post('/api/future-booking-assignment', {
          booking_id: bookingId,
          vehicle_id: vehicleIdInt,
          assigned_by: operatorName,
          source: 'unlocked_bookings'
        });
      }

      if (response.data && response.data.success) {
        toast.success(
          assignMode === 'hourly'
            ? `Vehicle ${assignVehicleId} assigned immediately to hourly booking #${bookingId}`
            : `Vehicle ${assignVehicleId} assigned to booking #${bookingId} as future booking`
        );
        this.setState({ assignVehicleId: '' }); // Reset field
        if (onSuccess) onSuccess(); // Call parent's success handler
        if (onClose) onClose(); // Close modal
      } else {
        throw new Error(response.data?.message || 'Failed to assign vehicle');
      }
    } catch (error) {
      console.error('Error assigning vehicle:', error);
      toast.error(error.response?.data?.detail || 'Failed to assign vehicle');
    } finally {
      this.setState({ isAssigning: false });
    }
  }

  handleClose = () => {
    const { onClose } = this.props;
    this.setState({ assignVehicleId: '' }); // Reset on close
    if (onClose) onClose();
  }

  render() {
    const { isOpen, booking, assignMode = 'future' } = this.props;
    const { assignVehicleId, isAssigning } = this.state;
    const bookingId = booking?.id || booking?.booking_id;
    const isHourlyMode = assignMode === 'hourly';

    return (
      <Modal isOpen={isOpen} toggle={this.handleClose}>
        <ModalHeader toggle={this.handleClose}>
          {isHourlyMode ? 'Assign Vehicle to Hourly Booking' : 'Assign Vehicle to Booking'} #{bookingId}
        </ModalHeader>
        <ModalBody>
          <p className="text-muted mb-3">
            <i className="fa fa-info-circle mr-2" />
            {isHourlyMode
              ? 'Assigning here creates trip immediately (received status) without waiting for next scheduler run.'
              : 'Assign a vehicle to this future booking. This will reserve the vehicle for this booking.'}
          </p>
          <FormGroup>
            <Label for="assignVehicleId">Vehicle ID *</Label>
            <Input
              type="number"
              id="assignVehicleId"
              name="assignVehicleId"
              placeholder="Enter vehicle ID (e.g., 1, 2, 3...)"
              value={assignVehicleId}
              onChange={(e) => this.setState({ assignVehicleId: e.target.value })}
              disabled={isAssigning}
              autoFocus
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={this.handleClose} disabled={isAssigning}>
            Cancel
          </Button>
          <Button 
            color="success" 
            onClick={this.handleConfirmAssignVehicle}
            disabled={isAssigning || !assignVehicleId.trim()}
          >
            {isAssigning ? (
              <>
                <i className="fa fa-spinner fa-spin mr-2" />
                Assigning...
              </>
            ) : (
              <>
                <i className="fa fa-check mr-2" />
                {isHourlyMode ? 'Assign Now' : 'Confirm Assignment'}
              </>
            )}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default AssignUnlocked;
